import React from 'react'
import { ComplaintForm } from '../ComplaintForm'
import { dateToString } from '../../utilities/methods/dateToString'
import {
  formDataForRequestComplainant,
  formDataForRequestVictim,
  normalizeSubjectData,
  normalizeWitnessData,
  saveComplaint
} from '../../utilities'
import { withRouter } from 'react-router-dom'

/*
 * An abstract component for creating specific complaints
 */
export class Complaint extends React.Component {
  constructor(props) {
    super(props)
    this.complaintType = 'unknown_complaint'
    this.formatComplaintForRequest = this.formatComplaintForRequest.bind(this)
    this.saveFormData = this.saveFormData.bind(this)
    this.source = 'web'
  }

  /*
   * Process the formData that is common to every complaint.
   * Convert the formData values into an object used by the API request.
   * detailData is the data unique for a sub-classed complaint.
   * Combine the unique data with the common data.
   */
  formatCommonComplaintFormData(formData, detailData = undefined) {
    // Get the values for detail and complaint from formData
    const {
      activity_end_date,
      communication_contact,
      communication_contact_other,
      confirmation_email,
      date_of_activity,
      documents,
      evidence_description,
      hhs_program,
      hhs_program_other,
      narrative,
      perm_to_disclose,
      previously_reported_date,
      still_occurring,
      subject_type_0
    } = formData

    // Check subject type to determine if it's a known subject
    const subject_is_known = subject_type_0 === 'unknown' ? 'False' : 'True'

    // RECAPTCHA value in props provided by withRecaptcha
    const recaptcha_score = this.props.recaptchaScore

    const detail = {
      communication_contact_date: dateToString(previously_reported_date),
      communication_contact,
      communication_contact_other,
      confirmation_email,
      disclosure_permission: perm_to_disclose,
      evidence_description,
      hhs_program,
      hhs_program_other,
      known_subject: subject_is_known,
      victim: formDataForRequestVictim(formData),
      ...detailData
    }

    const complaint_data = Object.freeze({
      complaint_type: this.complaintType,
      analyst_complaint_type: this.complaintType,
      activity_end_date: dateToString(activity_end_date),
      still_occurring,
      date_of_activity: dateToString(date_of_activity),
      complainant: formDataForRequestComplainant(formData),
      detail,
      documents,
      narrative,
      recaptcha_score,
      source: this.source,
      subjects: normalizeSubjectData(formData, 9),
      witnesses: normalizeWitnessData(formData, 4)
    })

    return complaint_data
  }

  /*
   * Convert formData to a data object for the API request.
   * Most Complaint sub-classes will override this method
   * to process the data unique to that complaint.
   */
  formatComplaintForRequest(formData) {
    return this.formatCommonComplaintFormData(formData)
  }

  /*
   * Convert the form data to a complaint object.
   * Call the method to save the complaint by posting to the API.
   * Redirect to the next URL, success or failure.
   * Is called when user clicks submit button.
   */
  saveFormData(formData) {
    saveComplaint(
      this.formatComplaintForRequest(formData),
      this.props.history,
      this.successURL
    )
  }

  render() {
    return <ComplaintForm schema={this.schema} />
  }
}

export default withRouter(Complaint)
